import { AuthType } from '@office-start/auth-types';
import { appendQuery, buildQueryPath, getLocation, getQueryParams, } from '@office-start/url-parser-utility';
var pvrQueryName = 'auth_pvr';
var upnQueryName = 'auth_upn';
export function appendPvrAndUpnAuthParams(url, swayOptions) {
    var authType = swayOptions.authType, userPrincipalName = swayOptions.userPrincipalName;
    var authParams;
    if (userPrincipalName && authType !== AuthType.Unknown) {
        var params_1 = {};
        params_1[pvrQueryName] = authType === 1 ? 'OrgId' : 'WindowsLiveId';
        params_1[upnQueryName] = userPrincipalName;
        authParams = buildQueryPath(params_1);
    }
    if (!url || !authParams) {
        return url;
    }
    var location = getLocation(url);
    var params;
    if (location) {
        params = getQueryParams(location === null || location === void 0 ? void 0 : location.search);
    }
    if ((params === null || params === void 0 ? void 0 : params.pvrQueryName) || (params === null || params === void 0 ? void 0 : params.upnQueryName)) {
        return url;
    }
    return appendQuery(url, authParams);
}
//# sourceMappingURL=appendPvrAndUpnAuthParams.js.map